import { host } from 'src/Branding/config';

export const useQueryInvestigationBegan = () => {
	const queryParams = new URLSearchParams(window.location.search);
	const sc = queryParams.get('sc');

	const investigationBegan = async () => {
		if (!sc) {
			console.error('No SC found in query params');
			return;
		}

		const url = new URL(host + '/api/investigationBegan');
		url.searchParams.append('sc', sc);

		const requestOptions = {
			method: 'GET',
		};

		return await fetch(url, requestOptions)
			.then((resData) => {
				return resData;
			})
			.catch((err: any) => {
				console.error('Error sending investigation began event', err);
			});
	};

	return { investigationBegan };
};
